var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16196 3.89488C7.4329 3.85482 7.7124 3.83333 8.00028 3.83333C11.4036 3.83333 13.6369 6.83656 14.3871 8.02455C14.4779 8.16833 14.5233 8.24023 14.5488 8.35112C14.5678 8.43439 14.5678 8.56578 14.5487 8.64905C14.5233 8.75993 14.4776 8.8323 14.3861 8.97705C14.1862 9.29343 13.8814 9.73807 13.4777 10.2203M4.48288 4.97669C3.0415 5.95447 2.06297 7.31292 1.61407 8.02352C1.52286 8.16791 1.47725 8.24011 1.45183 8.35099C1.43273 8.43426 1.43272 8.56563 1.45181 8.64891C1.47722 8.75979 1.52262 8.83168 1.61342 8.97545C2.36369 10.1634 4.59694 13.1667 8.00028 13.1667C9.37255 13.1667 10.5546 12.6784 11.5259 12.0177M2.00028 2.5L14.0003 14.5M6.58606 7.08579C6.22413 7.44772 6.00028 7.94772 6.00028 8.5C6.00028 9.60457 6.89571 10.5 8.00028 10.5C8.55256 10.5 9.05256 10.2761 9.41449 9.91421",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.57690bf231fd31c20a59e0bb7ffe636b.svg";
export { ForwardRef as ReactComponent };